import { toast } from '@webapp/components/Notification'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { useQueryFinancialAccountBalanceSummary } from '../../models/useQueryFinancialAccountBalanceSummary'

export const useGetFinancialAccountBalanceSummaryPresenter = ({
  financialAccountId,
  enabled = true,
  scaToken,
  showErrorToast = true,
  onLoadError,
}: {
  financialAccountId: number | undefined
  enabled?: boolean
  scaToken?: string
  showErrorToast?: boolean
  onLoadError?: () => void
}) => {
  const intl = useProcurifyIntl()

  const { balanceSummary, updatedAt, isFetching, isError } =
    useQueryFinancialAccountBalanceSummary({
      financialAccountId,
      enabled,
      scaToken,
      onError: () => {
        if (onLoadError) {
          onLoadError()
        } else if (showErrorToast) {
          toast.error({
            title: intl.formatMessage(
              messages.fetchingBalanceSummaryToastError
            ),
          })
        }
      },
    })

  return {
    data: {
      balanceSummary,
      updatedAt,
    },
    states: {
      isFetching,
      isError,
    },
  }
}
